<template>
  <div class="container mainContent">
    <h2>Test Page</h2>

    <p>You could have some other content here!</p>
  </div>
</template>

<script>
export default {
  name: "testpage"
}
</script>



/** WEBPACK FOOTER **
 ** testpage.vue?0e2368a4
 **/